import React, { useContext } from "react";
import { AppContext } from "../../util/AppContext";
import { getConfigValue } from "../../util/getConfigValue";
import PropTypes from 'prop-types';
import prettyDate from '../../util/prettyDate';
import {printJobStatus} from '../../util/constants';

DashboardItemRowHistoryItem.propTypes = {
    historyItem: PropTypes.any.isRequired,
};

function DashboardItemRowHistoryItem({ historyItem }) {
    const [appState] = useContext(AppContext);
    const createdOn = prettyDate(historyItem.createdOnUtc, (getConfigValue(appState?.config?.System?.DateTime?.Format, appState)?.Value || null));

    function getItemStatus(status) {
        switch (status) {
            case printJobStatus.Error:
                return getConfigValue(appState?.config?.ProfessionalPrinting.History.Status.Error, appState)?.Value || null;
            case printJobStatus.Completed:
                return getConfigValue(appState?.config?.ProfessionalPrinting.History.Status.Completed, appState)?.Value || null;
            case printJobStatus.Cancelled:
                return getConfigValue(appState?.config?.ProfessionalPrinting.History.Status.Cancelled, appState)?.Value || null;
            default:
                return getConfigValue(appState?.config?.ProfessionalPrinting.History.Status.Queued, appState)?.Value || null;
        }
    }

    function getIconClass(status) {
        switch (status) {
            case printJobStatus.Error:
                return "fa-circle-exclamation text-warning";
            case printJobStatus.Completed:
                return "fa-check text-success"
            default:
                return ""
        }
    }

    return (
        <div className="row align-items-lg-center mx-0 py-2 border-bottom">
            <div className="pd-plan-col col-sm col-lg-4 offset-lg-1">
                <div className="row align-items-lg-center">
                    <div className="col-12">
                        <span className={`d-block ${historyItem.status === printJobStatus.Cancelled ? "text-bold" : ""}`}>
                            {createdOn}
                        </span>
                    </div>
                </div>
            </div>
            <div className="pd-plan-col col-sm col-lg-3">
                <div className="row align-items-lg-center">
                    <div className="col-sm col-lg">
                        <span className="pd-plan-table-label d-block d-lg-none"></span>
                        {historyItem.status !== printJobStatus.Cancelled && 
                            <span className={'fa-regular me-2 ' + getIconClass(historyItem.status)}></span>
                        }
                        <span className={`${historyItem.status === printJobStatus.Cancelled ? "text-bold" : ""}`}>
                            {getItemStatus(historyItem.status)}
                        </span>                           
                    </div>
                </div>
            </div>
            <div className="pd-plan-col col-sm col-lg-4">
                <div className="row align-items-lg-center">
                    <div className="col-sm col-lg">
                        <span className="pd-plan-table-label d-block d-lg-none"></span>
                        {historyItem.status === printJobStatus.Cancelled && 
                        <div>
                        <span className="text-bold">{getConfigValue(appState?.config?.ProfessionalPrinting?.PrintVendorSubmissionMaxRetriesExceeded?.Error, appState)?.Value || null}</span>
                        </div>
                        }
                        
                    </div>
                </div>
            </div>
        </div>
    );
}
export default DashboardItemRowHistoryItem;
